import React from 'react'
import OverdueInvoices from '../features/OverdueInvoices/OverdueInvoices'

function Overdue_Invoice() {
  return (
    <OverdueInvoices />
  )
}

export default Overdue_Invoice